export default __webpack_public_path__ + "static/media/cyl_example_zatvor.f658510c.png";